export default "__VITE_ASSET__DTL4jYsc__"